export default function LinksGridSkeleton() {
  return (
    <section className="container mx-auto w-full animate-pulse">
      <div className="container mx-auto px-4">
        <div className="mb-6 h-8 w-64 rounded bg-gray-200"></div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="h-24 rounded-lg bg-gray-200"></div>
          ))}
        </div>
      </div>
    </section>
  );
}
